import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowBoldLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M22.796 14.4 12.236 24l10.56 9.6v-3.84h9.6V18.24h-9.6z" })
});
export default SvgArrowBoldLeft;
